import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BlurhashPlaceholderComponent } from '../../components/blurhash-placeholder/blurhash.component';
import type { ImageResult, UnsplashPhotoUrls } from '../../types';
import { IMAGE_UTMS } from '@sites/images/src/app/constants';

@Component({
    selector: 'sp-single-image',
    templateUrl: './single-image.component.html',
    styleUrls: ['./single-image.component.less'],
    imports: [CommonModule, BlurhashPlaceholderComponent],
})
export class SingleImageComponent {
    @Input() image!: ImageResult;
    @Input() size: keyof UnsplashPhotoUrls = 'regular';

    @Output() imageClick = new EventEmitter<ImageResult>();

    public isLoaded: boolean = false;
    public IMAGE_UTMS = IMAGE_UTMS;
}
